import { createMachine } from "xstate";

export const segmentsSelectionMachine = createMachine({
  id: "segment-selection",
  initial: "select",
  states: {
    select: {
      on: {
        SELECT_NEW: {
          target: "select",
          actions: "selectNew",
        },
        SELECT_ADD_XOR: {
          target: "select",
          actions: "selectAddXor",
        },
        LASSO_SELECT: {
          target: "select_with_lasso",
        },
        POLYGON_SELECT: {
          target: "select_with_polygon",
        },
        DRAW_SEGMENT: {
          target: "draw",
        },
        CANCEL: { actions: [] },
      },
    },
    select_with_lasso: {
      // entry: ["resetDrawing"],
      on: {
        SELECT_NEW: {
          target: "select",
          actions: "selectNew",
        },
        SELECT_ADD: {
          target: "select",
          actions: "selectAdd",
        },
        DRAW_SEGMENT: {
          target: "draw",
        },
        CANCEL: { target: "select", actions: [] },
      },
    },
    select_with_polygon: {
      on: {
        SELECT_NEW: {
          target: "select",
          actions: "selectNew",
        },
        SELECT_ADD: {
          target: "select",
          actions: "selectAdd",
        },
        DRAW_SEGMENT: {
          target: "draw",
        },
        CANCEL: { target: "select", actions: [] },
      },
    },
    draw: {
      on: {
        LASSO_SELECT: {
          target: "select_with_lasso",
        },
        CREATE_SEGMENT: {
          target: "select",
          actions: ["createNewSegment"],
        },
        CANCEL: { target: "select", actions: [] },
      },
    },
  },
});
